class PortraitVideo extends HTMLElement {
    constructor() {
        super();

        this.isPlaying = this.classList.contains("autoplay");

        const id = this.getAttribute("data-id");
        this.popup = document.querySelector(`insta-stories-popup[data-id='${id}']`);
        this.video = this.popup.querySelector("video");
        this.imageInterval;

        this.addEventListener(
            "click",
            this.play.bind(this)
        );

        this.popup.querySelector(".blocks-videos__list-item--popup-close").addEventListener(
            "click",
            this.close.bind(this)
        );

        this.popup.querySelector(".blocks-videos__list-item--popup-prev").addEventListener(
            "click",
            this.prev.bind(this)
        );

        this.popup.querySelector(".blocks-videos__list-item--popup-next").addEventListener(
            "click",
            this.next.bind(this)
        );

        if (this.video) {
            this.video.addEventListener('timeupdate', this.updateProgressBar.bind(this));

            this.video.addEventListener('seeked', this.updateProgressBar.bind(this));

            this.video.addEventListener('play', this.updateProgressBar.bind(this));
            this.video.addEventListener('pause', this.updateProgressBar.bind(this));

            this.video.addEventListener('ended', () => {
                this.popup.style.setProperty('--progress-width', 90 + '%');
                this.close();
                if (this.popup.nextElementSibling) {
                    const stories = document.querySelector(`portrait-video[data-id='${this.popup.nextElementSibling.getAttribute("data-id")}']`);
                    stories.play();
                }

            });
        }
    }

    play() {
        this.isPlaying = true;

        document.querySelectorAll(`insta-stories-popup`).forEach((popup) => { popup.setAttribute("active", "false"); popup.querySelector("video")?.pause() });
        this.popup.setAttribute("active", "true");
        this.popup.querySelector("video")?.play();

        if (!this.video) {
            this.updateProgressBarWithImage();
        }
    }

    close() {
        if (this.isPlaying) {
            this.popup.querySelector("video")?.pause();
            this.popup.setAttribute("active", "false");
            this.popup.style.setProperty('--progress-width', 0 + '%');
            clearInterval(this.imageInterval);
        }
    }

    prev() {
        if (this.isPlaying) {
            this.popup.querySelector("video")?.pause();
            this.popup.setAttribute("active", "false");
            this.popup.style.setProperty('--progress-width', 0 + '%');
            clearInterval(this.imageInterval);
        }

        if (this.popup.previousElementSibling && this.popup.getAttribute("data-index") !== '1') {
            const stories = document.querySelector(`portrait-video[data-id='${this.popup.previousElementSibling.getAttribute("data-id")}']`);
            stories.play();
        } else {
            const section = this.popup.getAttribute("data-section");
            const stories = document.querySelectorAll(`portrait-video[data-section='${section}']`);
            let ultimo = stories[stories.length - 1];
            ultimo.play();
        }
    }

    next() {
        if (this.isPlaying) {
            this.popup.querySelector("video")?.pause();
            this.popup.setAttribute("active", "false");
            this.popup.style.setProperty('--progress-width', 0 + '%');
            clearInterval(this.imageInterval);
        }
        const section = this.popup.getAttribute("data-section");
        const stories = document.querySelectorAll(`portrait-video[data-section='${section}']`);

        if (this.popup.nextElementSibling && this.popup.getAttribute("data-index") !== `${stories.length}`) {
            const stories = document.querySelector(`portrait-video[data-id='${this.popup.nextElementSibling.getAttribute("data-id")}']`);
            stories.play();
        } else {
            const stories = document.querySelector(`portrait-video[data-section='${section}'][data-index='1']`);
            stories.play();
        }
    }

    updateProgressBar() {
        const percentage = (this.video.currentTime / this.video.duration) * 90;
        this.popup.style.setProperty('--progress-width', percentage + '%');
    }

    updateProgressBarWithImage() {
        let percentage = 0;
        this.imageInterval = setInterval(() => {
            if (percentage < 90) {
                percentage += 1;
                this.popup.style.setProperty('--progress-width', percentage + '%');
            } else {
                clearInterval(this.imageInterval);
                this.close();
                if (this.popup.nextElementSibling) {
                    const stories = document.querySelector(`portrait-video[data-id='${this.popup.nextElementSibling.getAttribute("data-id")}']`);
                    stories.play();
                }
            }
        }, 50);
    }
}

customElements.define("portrait-video", PortraitVideo);